import ApplicationAdapter from './application';

export default class AgreementPageAdapter extends ApplicationAdapter {
  pathForType() {
    return 'agreement-pages';
  }
}
